module.exports = fox._r("css/slick/fonts/slick.ttf", __webpack_public_path__ + "_/_/_/main/css/slick/fonts/3Hy7EDt.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/css/slick/fonts/slick.ttf
// module id = 116
// module chunks = 4